<template>
    <div class="loader">
        <v-progress-circular :indeterminate="true" size="50"></v-progress-circular>
    </div>
</template>

<script>
    export default {
        name: "InlineLoader"
    }
</script>

<style scoped>
.loader {
    text-align: center;
}
</style>